import { render, staticRenderFns } from "./CreateClientsAdmin.vue?vue&type=template&id=49e6ce88&"
import script from "./CreateClientsAdmin.vue?vue&type=script&lang=js&"
export * from "./CreateClientsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports